export enum Confirmation {
  yes = 'yes',
  no = 'no',
}

export enum AnswerType {
  None = 'none',
  Decline = 'decline-to-answer',
}

export interface Helper {
  name?: string;
  organization?: string;
  email?: string;
  phone?: string;
}
